module.exports = __webpack_public_path__ + "roboto-bold-webfont-f633cb5c651ba4d50791e1adf55d3c18.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-bold-webfont.woff2
// module id = 829
// module chunks = 70